import * as yup from "yup";

export const PhotoGalleryValidation = yup.object().shape({
    folder_id: yup.string().required("Folder is required"),
});
